export default {
    // loggedIn: state => !!state.currentUser,
    // userDetails: state => state.userDetails,
    // token: (state) => {
    //     return state.token
    // }
};